import { useCallback } from 'react';

const makePardotData = (form: HTMLFormElement) => {
  const fd = new FormData();
  new FormData(form).forEach((v, k) => {
    if (
      /^(email|company_name|family_name|given_name|telephone|department)$/.test(
        k
      )
    ) {
      fd.append(k, v);
    }
  });
  return fd;
};

export const usePardot = (pardotUrl?: string | null) => {
  return {
    onSubmit: useCallback(async (ev: React.FormEvent<HTMLFormElement>) => {
      if (!pardotUrl) {
        return true;
      }
      const form = ev.currentTarget;
      ev.preventDefault();

      await fetch(pardotUrl, {
        method: 'POST',
        body: makePardotData(form),
      }).finally(() => {
        form.submit();
      });
    }, []),
  };
};
